import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";

import {
  ref,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";
import { itemRouteBuilder, NamedRts } from "@/router";
import { LotUnit } from "@/store/modules/lotUnits";
import { genericSort, sortIcon } from "@/components/helpers";

export default defineComponent({
  name: "lotUnits",
  components: {
    LoadingAnimation,
  },

  setup(_props, ctx) {
    let $store = ctx.root.$store;

    let dataLoaded = ref(false);
    let loadingMessage = ref("Loading Lot Units...");

    const apiLotUnits = computed(() => {
      return $store.getters.lotUnitsForTable as LotUnit[];
    });

    const localLotUnits = ref<LotUnit[]>([]);

    const editRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.lotUnitEditForm, id);
    };

    const lotUnits = computed(() => {
      let tmpResults = [...localLotUnits.value];
      // filter the results here, if needed,
      return tmpResults;
    });

    // info for sort
    // let filter = ref("");

    let sortKey = ref<"name" | "description">("name");
    let sortAsc = ref(true);

    const localSortIcon = (lSortKey: "name" | "description") => {
      return sortIcon(sortAsc, sortKey, lSortKey);
    };

    const updateSort = (lSortKey: "name" | "description") => {
      localLotUnits.value = genericSort(
        [...localLotUnits.value],
        sortAsc,
        sortKey,
        lSortKey,
      );
    };

    onMounted(() => {
      const jsConn = new JSConn();
      $store.dispatch("needLotUnits", jsConn).then(() => {
        localLotUnits.value = [...apiLotUnits.value];
        // flip the sort, otherwise on load it would be off
        sortAsc.value = !sortAsc.value;
        updateSort(sortKey.value);
        dataLoaded.value = true;
      });
    });

    return {
      dataLoaded,
      loadingMessage,

      lotUnits,
      editRouteBuilder,

      updateSort,
      localSortIcon,
    };
  },
});
